import { fetchChangeDetails } from '@gp/services/changeLog';
import {
  // formatFilterFetchParams,
  formatSortFetchParams,
} from '../utils';

import type { SortBy } from 'tea-component/lib/table/addons';
import type {
  // IPipelineChangeDetailFilterConditionsVO,
  // IPipelineChangeDetailFilterVO,
  IPipelineChangeDetailDTO,
  IPipelineChangeDetailTableRecord,
} from '@gp/types/changeLog';

export const getSearchList = async (
  payload?: { projectName?: string },
  params?: {
    // filterConditions?: IPipelineChangeDetailFilterConditionsVO;
    // filter?: IPipelineChangeDetailFilterVO;
    sort?: SortBy<IPipelineChangeDetailTableRecord>[];
  },
): Promise<IPipelineChangeDetailDTO[]> => {
  const { projectName } = payload || {};
  const {
    // filterConditions,
    // filter,
    sort,
  } = params || {};
  // const filterParams = formatFilterFetchParams(filter, filterConditions);
  const sortParams = formatSortFetchParams(sort);
  const res = await fetchChangeDetails({
    start_date: '',
    end_date: '',
    pteam: [],
    studio: [],
    tab: [],
    update_user: [],
    stage: [],
    // ...filterParams,
    ...sortParams,
    // 搜索
    // @ts-ignore
    search_type: 'dim',
    // 搜索
    search: projectName || '',
    project_ids: [],
  });
  return res?.data?.list || [];
};
